(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elx-blend"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = new Map();
  const init = (scope) => {
    scope.querySelectorAll('[data-elx-blend-section]').forEach((root) => {
      if (roots.has(root)) return;
      const reflect = (blend) => {
        root.querySelectorAll('[data-elx-blend-card]').forEach((row) => {
          row.dataset.selected = String(row.dataset.elxBlendCard === blend);
        });
      };
      const onChange = (event) => reflect(event.detail.blend);
      document.addEventListener('elx:blend-change', onChange);
      roots.set(root, onChange);
      reflect(window.ElxLp?.getBlend() || 'unsweetened');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    roots.forEach((listener, root) => {
      if (event.target.contains(root)) {
        document.removeEventListener('elx:blend-change', listener);
        roots.delete(root);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    function init(root) {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const galleries = new Map();
      const radios = [...root.querySelectorAll('[data-blend]')];
      const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pauseMedia = (scope) => {
        scope.querySelectorAll('video, model-viewer').forEach(media => media.pause?.());
        scope.querySelectorAll('iframe').forEach(frame => {
          if (frame.dataset.elxPlaying !== 'false') {
            frame.src = frame.src;
            frame.dataset.elxPlaying = 'false';
          }
        });
      };
      const mountGallery = (gallery) => {
        if (galleries.has(gallery)) {
          const pair = galleries.get(gallery);
          pair.main.reInit();
          pair.thumbs.reInit();
          pair.sync();
          return;
        }
        if (typeof window.EmblaCarousel !== 'function') return;
        const carouselOptions = { align: 'start', containScroll: 'trimSnaps', slidesToScroll: 1 };
        const main = window.EmblaCarousel(gallery.querySelector('[data-main-viewport]'), carouselOptions);
        const thumbs = window.EmblaCarousel(gallery.querySelector('[data-thumbs-viewport]'), carouselOptions);
        const buttons = [...gallery.querySelectorAll('[data-thumbnail]')];
        const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
        const sync = () => {
          const selected = main.selectedScrollSnap();
          buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === selected)));
          slides.forEach((slide, index) => {
            slide.inert = index !== selected;
            slide.setAttribute('aria-hidden', String(index !== selected));
            if (index !== selected) pauseMedia(slide);
            else slide.querySelectorAll('iframe').forEach(frame => { frame.dataset.elxPlaying = 'true'; });
          });
          // Keep one thumbnail visible before the selected one, so clicking the first visible thumbnail
          // slides the strip back the same way clicking the last one slides it forward.
          const snaps = thumbs.scrollSnapList().length;
          thumbs.scrollTo(Math.min(Math.max(selected - 1, 0), snaps - 1), reducedMotion());
        };
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => main.scrollTo(index, reducedMotion()), options);
        });
        main.on('select', sync);
        main.on('reInit', sync);
        galleries.set(gallery, { main, thumbs, sync });
        sync();
      };
      const syncPurchase = (form, purchase) => {
        const subscribed = purchase ? purchase === 'subscription' : Boolean(form.querySelector('[data-rtnu-selling-plan][name="selling_plan"]')?.value);
        const submit = form.querySelector('[data-submit]');
        if (submit) submit.textContent = subscribed ? root.dataset.subscribeLabel : root.dataset.addLabel;
        form.querySelectorAll('.rtnu-product__dynamic-checkout-terms').forEach(terms => { terms.hidden = !subscribed; });
      };
      const applyBlend = (blend) => {
        const radio = radios.find(input => input.dataset.blend === blend) || radios[0];
        if (!radio) return;
        radio.checked = true;
        const selected = radio.dataset.blend;
        root.querySelectorAll('[data-purchase]').forEach(panel => { panel.hidden = panel.dataset.purchase !== selected; });
        root.querySelectorAll('[data-purchase-fact]').forEach(fact => { fact.hidden = fact.dataset.purchaseFact !== selected; });
        root.querySelectorAll('[data-gallery]').forEach(gallery => {
          const wasHidden = gallery.hidden;
          gallery.hidden = gallery.dataset.gallery !== selected;
          if (gallery.hidden && !wasHidden) pauseMedia(gallery);
        });
        const activeGallery = root.querySelector(`[data-gallery="${selected}"]`);
        if (activeGallery) mountGallery(activeGallery);
      };
      root.addEventListener('change', event => {
        if (!event.target.matches('[data-blend]')) return;
        applyBlend(event.target.dataset.blend);
        window.ElxLp?.setBlend(event.target.dataset.blend, root);
      }, options);
      root.addEventListener('rtnu:buybox:change', event => {
        const form = event.target.closest('form');
        if (form && root.contains(form)) syncPurchase(form, event.detail?.purchase);
      }, options);
      document.addEventListener('elx:blend-change', event => {
        if (event.detail?.source !== root) applyBlend(event.detail?.blend);
      }, options);
      root.addEventListener('submit', event => {
        if (event.target.closest('[data-purchase]')?.hidden) event.preventDefault();
      }, options);
      const start = () => {
        window.rtnu?.initBuybox?.();
        root.querySelectorAll('form').forEach(form => syncPurchase(form));
        applyBlend(window.ElxLp?.getBlend() || radios[0]?.dataset.blend);
      };
      instances.set(root, () => {
        controller.abort();
        galleries.forEach(({ main, thumbs }) => { main.destroy(); thumbs.destroy(); });
        pauseMedia(root);
      });
      start();
      // Deferred shared assets may finish after Shopify's section script.
      document.addEventListener('DOMContentLoaded', start, { ...options, once: true });
      window.addEventListener('load', start, { ...options, once: true });
    }
    const scan = scope => {
      if (scope.matches?.('[data-elx-buybox]')) init(scope);
      scope.querySelectorAll('[data-elx-buybox]').forEach(init);
    };
    scan(document);
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      instances.forEach((destroy, root) => {
        if (event.target === root || event.target.contains(root)) { destroy(); instances.delete(root); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-close"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    const init = (root) => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      // Same contract as the S9 host: rtnu-buybox owns plan inputs, the host owns CTA copy and terms.
      const syncPurchase = (form, purchase) => {
        const subscribed = purchase ? purchase === 'subscription' : Boolean(form.querySelector('[data-rtnu-selling-plan][name="selling_plan"]')?.value);
        const submit = form.querySelector('[data-submit]');
        if (submit) submit.textContent = subscribed ? root.dataset.subscribeLabel : root.dataset.addLabel;
        // The title price follows the selected option: the plan's total today, or the Buy once price.
        const card = form.closest('.elx-close__card');
        const priceEl = card?.querySelector('[data-elx-close-price]');
        const checked = form.querySelector('.rtnu-buybox__input:checked');
        if (priceEl && checked) {
          const source = checked.value === 'onetime'
            ? form.querySelector('[data-rtnu-buybox-once-price]')
            : checked.closest('[data-rtnu-buybox-plan]')?.querySelector('[data-rtnu-buybox-price]');
          const text = source?.textContent.trim();
          if (text) priceEl.textContent = text;
        }
        form.querySelectorAll('.rtnu-product__dynamic-checkout-terms').forEach((terms) => { terms.hidden = !subscribed; });
      };
      // Each card's form reports its own change; no shared blend state is read or written here.
      root.addEventListener('rtnu:buybox:change', (event) => {
        const form = event.target.closest('form');
        if (form && root.contains(form)) syncPurchase(form, event.detail?.purchase);
      }, options);
      const start = () => {
        window.rtnu?.initBuybox?.();
        root.querySelectorAll('form').forEach((form) => syncPurchase(form));
      };
      instances.set(root, () => controller.abort());
      start();
      // Deferred shared assets may finish after Shopify's section script.
      document.addEventListener('DOMContentLoaded', start, { ...options, once: true });
      window.addEventListener('load', start, { ...options, once: true });
    };
    const scan = (scope) => {
      if (scope.matches?.('[data-elx-close]')) init(scope);
      scope.querySelectorAll('[data-elx-close]').forEach(init);
    };
    scan(document);
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((destroy, root) => {
        if (event.target === root || event.target.contains(root)) { destroy(); instances.delete(root); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-ingredients"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ElxIngredients) {
      window.ElxIngredients.init(document);
      return;
    }
    const roots = new Set();
    const reflect = (root, blend) => {
      if (blend !== 'unsweetened' && blend !== 'nectar') return;
      root.dataset.blend = blend;
      root.querySelectorAll('[data-elx-select-blend]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.elxSelectBlend === blend));
      });
      root.querySelectorAll('[data-elx-amount]').forEach((amount) => {
        amount.setAttribute('aria-hidden', String(amount.dataset.elxAmount !== blend));
      });
    };
    const init = (scope) => {
      const candidates = Array.from(scope.querySelectorAll('[data-elx-ingredients]'));
      if (scope.matches && scope.matches('[data-elx-ingredients]')) candidates.push(scope);
      candidates.forEach((root) => {
        roots.add(root);
        reflect(root, window.ElxLp ? window.ElxLp.getBlend() : 'unsweetened');
      });
    };
    window.ElxIngredients = { init };
    document.addEventListener('elx:blend-change', (event) => {
      roots.forEach((root) => {
        if (!root.isConnected) roots.delete(root);
        else reflect(root, event.detail.blend);
      });
    });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      roots.forEach((root) => {
        if (root === event.target || event.target.contains(root)) roots.delete(root);
      });
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-left-out"] && !Shopify.designMode) return;
  try {
    
  /*
    Exclusion accordion: one row open at a time. Listeners are delegated from document, so a section
    re-rendered by the theme editor (shopify:section:load) needs no re-init and
    shopify:section:unload leaves nothing to clean up.
  */
  (() => {
    if (window.elxLeftOutBound) return;
    window.elxLeftOutBound = true;

    const setOpen = (button, open) => {
      button.setAttribute('aria-expanded', String(open));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !open;
    };

    const toggle = (button, open) => {
      const root = button.closest('[data-elx-left-out]');
      if (open && root) {
        root.querySelectorAll('[data-elx-left-out-toggle][aria-expanded="true"]').forEach((other) => {
          if (other !== button) setOpen(other, false);
        });
      }
      setOpen(button, open);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-elx-left-out-toggle]');
      if (button) toggle(button, button.getAttribute('aria-expanded') !== 'true');
    });

    // Theme editor: open the row whose block is selected in the sidebar.
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('[data-elx-left-out-item]');
      const button = item && item.querySelector('[data-elx-left-out-toggle]');
      if (button) toggle(button, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-line"] && !Shopify.designMode) return;
  try {
    
  /*
    Where we drew the line: height transition for the native details rows. Without JS the rows
    still open and close natively. Only one row per list opens at a time. Listeners are delegated from document,
    so a section re-rendered by the theme editor (shopify:section:load) needs no re-init and
    shopify:section:unload leaves nothing to clean up.
  */
  (() => {
    if (window.elxLineBound) return;
    window.elxLineBound = true;

    const CLOSING = 'elx-line__item--closing';
    const ANIMATING = 'elx-line__item--animating';
    const DURATION = 300;
    const EASING = 'cubic-bezier(0.2, 0, 0, 1)';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const running = new WeakMap();

    const isOpen = (item) => item.open && !item.classList.contains(CLOSING);

    const settle = (item) => {
      running.delete(item);
      item.classList.remove(ANIMATING, CLOSING);
    };

    const setOpen = (item, open) => {
      if (open) {
        item.closest('.elx-line__list')?.querySelectorAll('[data-elx-line-item]').forEach((other) => {
          if (other === item) return;
          const animation = running.get(other);
          if (animation) animation.cancel();
          other.open = false;
          settle(other);
        });
      }
      // Start from the current rendered height, mid-animation included.
      const from = item.offsetHeight;
      const active = running.get(item);
      if (active) active.cancel();
      settle(item);

      item.open = open;
      const to = item.offsetHeight;
      if (reducedMotion.matches || typeof item.animate !== 'function' || from === to) return;

      // Closing keeps [open] until the animation ends so the panel stays visible while it shrinks.
      if (!open) {
        item.open = true;
        item.classList.add(CLOSING);
      }
      item.classList.add(ANIMATING);

      const animation = item.animate({ height: [`${from}px`, `${to}px`] }, { duration: DURATION, easing: EASING });
      running.set(item, animation);
      animation.onfinish = () => {
        if (!open) item.open = false;
        settle(item);
      };
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-elx-line-toggle]');
      const item = toggle && toggle.closest('[data-elx-line-item]');
      if (!item) return;
      event.preventDefault();
      setOpen(item, !isOpen(item));
    });

    // Theme editor: open the row whose block is selected in the sidebar.
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('[data-elx-line-item]');
      if (item) setOpen(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elx-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const reservedHeights = new Map();
  let originalPadding;
  let originalPriority;
  let basePadding = 0;
  const reserve = (root, height) => {
    if (height && !reservedHeights.size) {
      originalPadding = document.body.style.getPropertyValue('padding-bottom');
      originalPriority = document.body.style.getPropertyPriority('padding-bottom');
      basePadding = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
    }
    if (height) reservedHeights.set(root, height);
    else reservedHeights.delete(root);
    const clearance = reservedHeights.size ? Math.max(...reservedHeights.values()) : 0;
    document.documentElement.classList.toggle('has-elx-sticky-atc', clearance > 0);
    if (clearance) document.documentElement.style.setProperty('--elx-sticky-clearance', `${clearance}px`);
    else document.documentElement.style.removeProperty('--elx-sticky-clearance');
    if (reservedHeights.size) {
      document.body.style.setProperty('padding-bottom', `${basePadding + Math.max(...reservedHeights.values())}px`);
    } else if (originalPadding !== undefined) {
      if (originalPadding) document.body.style.setProperty('padding-bottom', originalPadding, originalPriority);
      else document.body.style.removeProperty('padding-bottom');
      originalPadding = undefined;
    }
  };
  const init = (root) => {
    if (instances.has(root)) return;
    const select = root.querySelector('select');
    const input = root.querySelector('input[name="id"]');
    const button = root.querySelector('button');
    const form = root.querySelector('form');
    const mobile = matchMedia('(max-width: 767px)');
    let selected = false;
    let anchors = [];
    let frame = 0;
    const applyBlend = (blend) => {
      if (!select || !button) return;
      const option = Array.from(select.options).find((item) => item.value === blend);
      if (!option) return;
      select.value = blend;
      root.dataset.blend = blend;
      root.querySelector('.elx-sticky-atc__meta [data-price]').textContent = option.dataset.price;
      root.querySelectorAll('[data-blend-image]').forEach((image) => { image.hidden = image.dataset.blendImage !== blend; });
      const available = Boolean(form && option.dataset.variant && option.dataset.available === 'true');
      if (input) { input.value = option.dataset.variant; input.disabled = !available; }
      button.disabled = !available;
      button.textContent = available ? root.dataset.cta : root.dataset.unavailable;
    };
    const update = () => {
      const [blend, buy, close, footer] = anchors;
      const inView = (anchor) => {
        if (!anchor || !anchor.getClientRects().length) return false;
        const rect = anchor.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      };
      const passed = blend && blend.getClientRects().length && blend.getBoundingClientRect().bottom <= 0;
      const visible = Boolean(mobile.matches && (selected || root.dataset.preview === 'true' || (passed && !inView(buy) && !inView(close) && !inView(footer))));
      root.classList.toggle('is-visible', visible);
      root.inert = !visible;
      root.setAttribute('aria-hidden', String(!visible));
      reserve(root, visible ? root.getBoundingClientRect().height : 0);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; update(); });
    };
    const observer = new IntersectionObserver(schedule, { root: null, rootMargin: '0px', threshold: 0 });
    const refresh = () => {
      observer.disconnect();
      anchors = ['elx-blend', 'elx-buy', 'elx-close'].map((id) => document.getElementById(id)).concat(document.querySelector('.rtnu-footer'));
      anchors.filter(Boolean).forEach((anchor) => observer.observe(anchor));
      update();
    };
    const resize = new ResizeObserver(schedule);
    resize.observe(root);
    const onChange = () => { applyBlend(select.value); window.ElxLp?.setBlend(select.value, root); };
    const onBlend = (event) => { if (event.detail.source !== root) applyBlend(event.detail.blend); };
    const onSelect = (event) => { if (event.detail.sectionId === root.dataset.sectionId) { selected = true; update(); } };
    const onDeselect = (event) => { if (event.detail.sectionId === root.dataset.sectionId) { selected = false; update(); } };
    const onSubmit = (event) => { if (!input || input.disabled || !input.value || !button || button.disabled) event.preventDefault(); };
    select?.addEventListener('change', onChange);
    form?.addEventListener('submit', onSubmit);
    document.addEventListener('elx:blend-change', onBlend);
    document.addEventListener('shopify:section:select', onSelect);
    document.addEventListener('shopify:section:deselect', onDeselect);
    mobile.addEventListener('change', update);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    instances.set(root, { refresh, destroy() {
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      select?.removeEventListener('change', onChange);
      form?.removeEventListener('submit', onSubmit);
      document.removeEventListener('elx:blend-change', onBlend);
      document.removeEventListener('shopify:section:select', onSelect);
      document.removeEventListener('shopify:section:deselect', onDeselect);
      mobile.removeEventListener('change', update);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      reserve(root, 0);
      instances.delete(root);
    } });
    applyBlend(window.ElxLp?.getBlend() || document.documentElement.dataset.elxBlend || 'unsweetened');
    refresh();
  };
  const scan = () => {
    document.querySelectorAll('[data-elx-sticky-atc]').forEach(init);
    instances.forEach((instance) => instance.refresh());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((instance, root) => { if (event.target.contains(root)) instance.destroy(); });
    requestAnimationFrame(() => instances.forEach((instance) => instance.refresh()));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-info-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize all info cards carousels on the page
    const carousels = document.querySelectorAll('.rtnu-info-cards-carousel');

    carousels.forEach((emblaNode) => {
      if (emblaNode._emblaInfoCardsInitialized) return; // Prevent double initialization

      const viewport = emblaNode.querySelector('.embla__viewport');
      const dotsContainer = emblaNode.querySelector('.embla__dots');

      if (!viewport) return;

      // Responsive options for different behavior on desktop vs mobile
      const isDesktop = window.innerWidth > 768;
      const options = {
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: isDesktop ? 'auto' : 1,
      };

      // Initialize Embla
      const embla = EmblaCarousel(viewport, options);

      // Check if scrolling is needed and add has-scrolling class
      const updateScrollingState = () => {
        const canScrollPrev = embla.canScrollPrev();
        const canScrollNext = embla.canScrollNext();
        const needsScrolling = canScrollPrev || canScrollNext;

        // Add/remove class for CSS styling
        if (needsScrolling) {
          emblaNode.classList.add('has-scrolling');
        } else {
          emblaNode.classList.remove('has-scrolling');
        }
      };

      // Pagination dots functionality
      const createDots = () => {
        if (!dotsContainer) return;

        const scrollSnaps = embla.scrollSnapList();
        const snapCount = scrollSnaps.length;
        dotsContainer.innerHTML = '';

        for (let i = 0; i < snapCount; i++) {
          const dot = document.createElement('button');
          dot.className = 'embla__dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to page ${i + 1}`);
          dot.addEventListener('click', () => embla.scrollTo(i));
          dotsContainer.appendChild(dot);
        }
      };

      const updateDots = () => {
        if (!dotsContainer) return;

        const dots = dotsContainer.querySelectorAll('.embla__dot');
        const selectedIndex = embla.selectedScrollSnap();

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-selected', index === selectedIndex);
        });
      };

      // Initialize dots and update on select
      embla.on('init', () => {
        createDots();
        updateDots();
        updateScrollingState();
      });

      embla.on('select', () => {
        updateDots();
        updateScrollingState();
      });

      // Handle resize with debounce
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          // Update options based on new screen size
          const isDesktop = window.innerWidth > 768;
          const newOptions = {
            align: 'start',
            containScroll: 'trimSnaps',
            slidesToScroll: isDesktop ? 'auto' : 1,
          };
          embla.reInit(newOptions);
          createDots();
          updateDots();
          updateScrollingState();
        }, 150);
      };

      window.addEventListener('resize', handleResize);

      // Cleanup function
      const cleanup = () => {
        window.removeEventListener('resize', handleResize);
        if (embla) embla.destroy();
      };

      // Store cleanup function and mark as initialized
      emblaNode._emblaInfoCardsCleanup = cleanup;
      emblaNode._emblaInfoCardsInitialized = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
